
import React, { useState, useEffect, useRef } from "react";
import SuperNavbar from "../components/SuperNavbar"
import img from "../assets/PLATFORMS.png"
import "./Sara.css";
import Top from "../components/Top";
import Footer from "../components/Footer";
import { Scrollbar } from 'react-scrollbars-custom';
import imag2 from "../assets/Home/cropped-sara2.png";
import sara from "../assets/sara/SARA.png"

const Products = () => {

   const [isHovered, setIsHovered] = useState(false);
   const [div1Visible, setDiv1Visible] = useState(false);
   const [div2Visible, setDiv2Visible] = useState(false);
   const [div3Visible, setDiv3Visible] = useState(false);
   const [hoveredIndex, setHoveredIndex] = useState(-1);
   const [clickedInside, setClickedInside] = useState(false);

   const handleMouseEnter2 = (index) => {
      setHoveredIndex(index);
   };

   const handleMouseLeave2 = () => {
      setHoveredIndex(-1);
   };

   const handleImageClick = (index) => {
      setHoveredIndex(hoveredIndex === index ? -1 : index);
      setClickedInside(true);
   };

   const handleDocumentClick = (event) => {
      if (!ref.current.contains(event.target)) {
         setHoveredIndex(-1);
      }
   };

   const isTextMiddle = (index) => hoveredIndex === index;

   useEffect(() => {
      document.body.addEventListener('click', handleDocumentClick);
      return () => {
         document.body.removeEventListener('click', handleDocumentClick);
      };
   }, []);

   const ref = useRef();

   const sectionRef = useRef(null);

   useEffect(() => {
      const observer = new IntersectionObserver(
         ([entry]) => {
            if (entry.isIntersecting) {
               setDiv1Visible(true);
            }
         },
         {
            root: null,
            rootMargin: '0px',
            threshold: 0.1, // Adjust as needed
         }
      );

      if (sectionRef.current) {
         observer.observe(sectionRef.current);
      }

      return () => {
         if (sectionRef.current) {
            observer.unobserve(sectionRef.current);
         }
      };
   }, []);

   useEffect(() => {
      const timeout1 = setTimeout(() => setDiv1Visible(true), 0);
      const timeout2 = setTimeout(() => setDiv2Visible(true), 1000);
      const timeout3 = setTimeout(() => setDiv3Visible(true), 2000);

      return () => {
         clearTimeout(timeout1);
         clearTimeout(timeout2);
         clearTimeout(timeout3);
      };
   }, []);

   const handleMouseEnter = () => {
      setIsHovered(true);
   };

   const handleMouseLeave = () => {
      setIsHovered(false);
   };

   const insights = [
      { url: require("../assets/sara/insight1.png"), className: "w-[450px] h-[300px]" },
      { url: require("../assets/sara/insight2.png"), className: "w-[450px] h-[300px]" },
      { url: require("../assets/sara/insight3.png"), className: "w-[450px] h-[300px]" },
      { url: require("../assets/sara/insight4.png"), className: "w-[450px] h-[300px]" }
   ];

   const Accountability = [
      { src: require("../assets/sara/trustwothy.png"), className: "hexagon surrounded w-full h-full object-fit" },
      { src: require("../assets/sara/privacy.png"), className: "hexagon surrounded w-full h-full object-fit" },
      { src: require("../assets/sara/Regulation2.png"), className: "hexagon surrounded w-full h-full object-fit" },
      { src: require("../assets/sara/SARA.png"), className: "hexagon w-full h-full object-fit" },
      { src: require("../assets/sara/TRANSPARANCY.png"), className: "hexagon surrounded w-full h-full object-fit" },
      { src: require("../assets/sara/Secure.png"), className: "hexagon surrounded w-full h-full object-fit" },
      { src: require("../assets/sara/Explainable.jpg"), className: "hexagon surrounded w-full h-full object-fit" }
   ];

   return (
      <div className="bg-opacity-90 w-[100%] text-[#FAE9CF]">
         <div className="bg-black mt-[85px] to-blue-900 flex w-full h-[90vh] justify-center gap-2 items-center bg-custom-gradient">
            <div className="w-[50%] h-full object-contain">
               <img src={require("../assets/SARA.png")} alt="" className="w-full h-[101%]" />
            </div>
            <div className="w-[50%] h-[50vh] flex flex-col justify-center items-center ">
               <h1 className="text-3xl font-serif text-black ml-8 justify-end">Revolutionize user engagement and conversion with our AI-powered recommendations, seamlessly delivered through interactive UI/UX elements, <br /> across multiple platforms.
               </h1>
            </div>
         </div>
         <div className="relative flex flex-col w-full justify-center items-center bg-gray-200 p-4 pb-8">
            <div className="flex w-full justify-center items-center p-10 ">
               <div className="w-[50%] rounded-full flex justify-center items-cente"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
               >
                  <div className="w-[640px] h-[360px]">
                     <img src={require("../assets/sara/personal.jpg")} alt="" className="rounded-xl w-full h-full object-fit transform transition-transform hover:scale-110" />
                  </div>
               </div>
               <div className="w-[50%] flex flex-col justify-center items-center">
                  {/* <h1 className="text-black text-3xl text-center font-serif">Personalized Recommendations</h1> */}
                  <h5 className="text-black text-xl text-left font-serif p-8">Personalizing User Experience has been a key driver of OTT app success. Horizon Recommendation Engine SARA uses AI and data analytics to understand user preferences and behavior, allowing for tailored content recommendations.
                     Personalization is evolving and becoming more refined and making an impact in industry</h5>
                  <div><h2 className="text-black text-3xl text-center font-serif">Recommendations Driven by AI
                     </h2><h5 className="text-black text-xl text-left font-serif p-8">Advanced AI algorithms provide reliable and accurate content recommendations. These algorithms consider factors like user history, viewing habits, and even real-time context to suggest the most relevant content. It helps users  to be more engaged and content discovery is made simplified based on user preferences. </h5>
                  </div>
                  <div><h2 className="text-black text-3xl text-center font-serif">Monetization
                     </h2><h5 className="text-black text-xl text-left font-serif p-8">OTT platforms are also integrating personalization into advertising. By analyzing user data, they can deliver targeted ads that are more likely to be relevant and engaging. This benefits both users and advertisers, as it increases the effectiveness of advertising while reducing the annoyance of irrelevant ads.</h5>
                  </div>
               </div>

            </div>
         </div>
         <div className="flex w-full h-[105vh] justify-center bg-gray-200">
            <div className="flex lg:flex-col gap-2 justify-center items-center">
               <h1 className="text-center text-5xl mb-12 font-serif my-3 text-black mt-5">WHAT MAKES S.A.R.A. SPECIAL</h1>

               <div className="md:flex justify-center gap-4 items-center">



                  <div className="w-[260px] h-[400px]">
                     <div className="relative w-[260px] h-[350px] perspective-1000 transform-style-preserve-3d transition-transform"
                        onMouseEnter={() => handleMouseEnter2(0)} onMouseLeave={handleMouseLeave2} onClick={() => handleImageClick(0)} ref={ref}>
                        <img src={require('../assets/sara/personalisation.jpg')} alt="" className="w-full h-full object-fit brightness-70" />
                        {isTextMiddle(0) ? (<div className="absolute w-full h-full inset-0 bg-black opacity-70"></div>) :
                           (<div className="absolute w-full h-full inset-0 bg-gradient-to-t from-black-100 via-black-200 to-black-500 opacity-20"></div>)
                        }
                        <div className={`absolute ${isTextMiddle(0) ? 'inset-0 left-[10%] font-bold text-[24px] flex justify-center items-center text-yellow-500' : 'bottom-0 left-[8%] font-bold text-[24px] text-center text-blue-500'} font-sans text-[21px]`}>Hyper-Personalize Engagement</div>
                     </div>
                     <div className="w-[260px] h-[50px] bg-gradient-to-t from-gray-700 to-gray-400"></div>
                  </div>



                  <div className="w-[260px] h-[400px]">
                     <div className="relative w-[260px] h-[350px] perspective-1000 transform-style-preserve-3d transition-transform"
                        onMouseEnter={() => handleMouseEnter2(1)} onMouseLeave={handleMouseLeave2} onClick={() => handleImageClick(1)} ref={ref}>
                        <img src={require('../assets/sara/boost2.png')} alt="" className="w-full h-full object-fit brightness-70" />
                        {isTextMiddle(1) ? (<div className="absolute w-full h-full inset-0 bg-black opacity-70"></div>) :
                           (<div className="absolute w-full h-full inset-0 bg-gradient-to-t from-black-100 via-black-200 to-black-500 opacity-20"></div>)
                        }
                        <div className={`absolute ${isTextMiddle(1) ? 'inset-0 flex font-bold text-[24px] justify-center items-center text-yellow-500' : 'bottom-0 left-[15%] font-bold text-[24px] text-center text-blue-500'} font-sans text-[21px]`}>Boost Satisfaction</div>
                     </div>
                     <div className="w-[260px] h-[50px] bg-gradient-to-t from-gray-700 to-gray-400"></div>
                  </div>

                  <div className="w-[260px] h-[400px]">
                     <div className="relative w-[260px] h-[350px] perspective-1000 transform-style-preserve-3d transition-transform"
                        onMouseEnter={() => handleMouseEnter2(2)} onMouseLeave={handleMouseLeave2} onClick={() => handleImageClick(2)} ref={ref}>
                        <img src={require('../assets/sara/RETENTION-4.png')} alt="" className="w-full h-full object-fit brightness-70" />
                        {isTextMiddle(2) ? (<div className="absolute w-full h-full inset-0 bg-black opacity-70"></div>) :
                           (<div className="absolute w-full h-full inset-0 bg-gradient-to-t from-black-100 via-black-200 to-black-500 opacity-20"></div>)
                        }
                        <div className={`absolute ${isTextMiddle(2) ? 'inset-0 font-bold text-[24px] flex justify-center items-center text-yellow-500' : 'bottom-0 left-[30%] font-bold text-[24px] text-center text-blue-500'} font-sans text-[21px]`}>Retention</div>
                     </div>
                     <div className="w-[260px] h-[50px] bg-gradient-to-t from-gray-700 to-gray-400"></div>
                  </div>

                  <div className="w-[260px] h-[400px]">
                     <div className="relative w-[260px] h-[350px] perspective-1000 transform-style-preserve-3d transition-transform"
                        onMouseEnter={() => handleMouseEnter2(3)} onMouseLeave={handleMouseLeave2} onClick={() => handleImageClick(3)} ref={ref}>
                        <img src={require('../assets/sara/Search.png')} alt="" className="w-full h-full object-fit brightness-70" />
                        {isTextMiddle(3) ? (<div className="absolute w-full h-full inset-0 bg-black opacity-70"></div>)
                           : (<div className="absolute w-full h-full inset-0 bg-gradient-to-t from-black-100 via-black-200 to-black-500 opacity-20"></div>)
                        }
                        <div className={`absolute ${isTextMiddle(3) ? 'inset-0 left-[5%] font-bold text-[24px] flex justify-center items-center text-yellow-500' : 'bottom-0 left-[5%] font-bold text-[24px] text-center text-blue-500'} font-sans`}>Multi-dimension search</div>
                     </div>
                     <div className="w-[260px] h-[50px] bg-gradient-to-t from-gray-700 to-gray-400"></div>
                  </div>

                  <div className="w-[260px] h-[400px]">
                     <div className="relative w-[260px] h-[350px] perspective-1000 transform-style-preserve-3d transition-transform"
                        onMouseEnter={() => handleMouseEnter2(4)} onMouseLeave={handleMouseLeave2} onClick={() => handleImageClick(4)} ref={ref}>
                        <img src={require('../assets/sara/Content.jpg')} alt="" className="w-full h-full object-fit brightness-70" />
                        {isTextMiddle(4) ? (<div className="absolute w-full h-full inset-0 bg-black opacity-70"></div>)
                           : (<div className="absolute w-full h-full inset-0 bg-gradient-to-t from-white to-black-500 opacity-20"></div>)
                        }
                        <div className={`absolute ${isTextMiddle(4) ? 'inset-0 font-bold text-[24px] flex justify-center items-center text-yellow-500' : 'bottom-0 left-[10%] font-bold text-[24px] text-center text-blue-500'} font-sans text-[21px]`}>Drive Content Quality</div>
                     </div>
                     <div className="w-[260px] h-[50px] bg-gradient-to-t from-gray-700 to-gray-400"></div>
                  </div>
               </div>
            </div>
         </div>

         <div className="relative flex flex-col w-full justify-center items-center bg-gray-200 p-4 pb-8">
            {/* <h1 className="text-5xl text-center mt-5 font-serif text-black">S.A.R.A. RECOMMENDATIONS</h1> */}
            {/* <div className="flex w-full justify-center items-center p-8">
               <div className="w-[50%] flex flex-col justify-center items-center">
                  <h1 className="text-black text-3xl text-center font-serif">Personalized Recommendations</h1>
                  <h5 className="text-black text-2xl text-center font-serif">When a user watches a movie with a specific cast and crew, they're inclined to enjoy similar content from our ML models</h5>
               </div>
               <div className="w-[50%] rounded-full flex justify-center items-cente"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
               >
                  <div className="w-[640px] h-[360px]">
                     <img src={require("../assets/sara/personal.jpg")} alt="" className="rounded-xl w-full h-full object-fit transform transition-transform hover:scale-110" />
                  </div>
               </div>
            </div> */}


            <div className="flex w-full justify-center items-center p-8">
               <div className="w-[50%] rounded-full flex justify-center items-center"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}>
                  <div className="w-[640px] h-[360px]">
                     <img src={require("../assets/sara/grouprecommendation.png")} alt="" className="rounded-xl w-full h-full object-fit transform transition-transform hover:scale-110" />
                  </div>
               </div>
               <div className="w-[50%] flex flex-col justify-center items-center">
                  <h1 className="text-black text-3xl text-center font-serif">Group Recommendations </h1>
                  <h5 className="text-black text-2xl text-center font-serif">Shared personas among users lead to a higher likelihood of them enjoying each other's recommendation. </h5>
               </div>
            </div>


            <div className="flex w-full justify-center items-center p-8">
               <div className="w-[50%] flex flex-col justify-center items-center">
                  <h1 className="text-black text-3xl text-center font-serif">Editorial Biases </h1>
                  <h5 className="text-black text-2xl text-center font-serif">Curated operator-selected editorial content</h5>
               </div>
               <div className="w-[50%] rounded-full flex justify-center items-center"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
               >
                  <div className="w-[640px] h-[360px]">
                     <img src={require("../assets/sara/curated.jpg")} alt="" className="rounded-xl w-full h-full object-fit transform transition-transform hover:scale-110" />
                  </div>
               </div>
            </div>


            <div className="flex w-full justify-center items-center p-8">
               <div className="w-[50%] flex justify-center items-center"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
               >
                  <div className="w-[640px] h-[360px]">
                     <img src={require("../assets/sara/searching.png")} alt="" className="rounded-xl w-full h-full object-fit transform transition-transform hover:scale-110" />
                  </div>
               </div>
               <div className="w-[50%] flex flex-col justify-center items-center">
                  <h1 className="text-black text-3xl text-center font-serif">Distributed Search</h1>
                  <h5 className="text-black text-2xl text-center font-serif">Search across EPG, LIVE TV, VOD Movies, Shows, Seasons with Fuzzy Search and Auto-complete</h5>
               </div>
            </div>


            <div className="flex w-full justify-center items-center p-8">
               <div className="w-[50%] flex flex-col justify-center items-center">
                  <h1 className="text-black text-3xl text-center font-serif">User Profiling</h1>
                  <h5 className="text-black text-2xl text-center font-serif">Profile users with unobtrusive, friendly and enticing prompts to get hyper-personalized data of each user</h5>
               </div>
               <div className="w-[50%] flex justify-center items-center"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
               >
                  <div className="w-[640px] h-[360px]">
                     <img src={require("../assets/Home/userprfiling.png")} alt="" className="rounded-xl w-full h-full object-fit transform transition-transform hover:scale-110" />
                  </div>
               </div>
            </div>
         </div>



         <div className="relative flex flex-col w-full h-[100vh] justify-center items-center gap-4 bg-gray-200 px-4 pb-8">
            <div className="w-[100%] flex flex-col justify-center items-center ">
               <h1 className="text-lg lg:text-5xl font-serif text-center text-black mb-1 mt-8">S.A.R.A. INSIGHTS</h1>
               <h5 className="text-sm lg:text-2xl font-serif text-center mb-1 text-black">Horizon harness innovative technology to deeply understand and enhance customer interactions , refining <br /> their processes and strategies meticulously to foster continuous growth and success in the online realm.
               </h5>
            </div>
            <div>
               <div className="w-[100%] grid grid-cols-2 gap-5"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}>
                  {insights.map((image, index) => (
                     <img key={index} src={image.url} alt="" className={`${image.className} transform transition-transform hover:scale-110`} />
                  ))}
               </div>
            </div>
         </div>


         {/* <div ref={sectionRef} className="relative flex flex-col w-full h-[100vh] text-black justify-center items-center bg-gray-200 px-5 pb-8">
            <h1 className="text-6xl text-green-500 font-serif w-full text-start">Retention</h1>
            <div className="relative w-[95%] h-[80%] z-1">
               <div className={`absolute bottom-0 left-0  w-[50%] z-1 h-[80%] ${div1Visible ? 'transition-opacity duration-1000 ease-in' : 'opacity-0'}`}><img src={require("../assets/sara/Retention-1.png")} className="w-full h-full object-fit rounded-lg" /></div>
               <div className={`absolute bottom-[8%] left-[30%] z-1 w-[50%] h-[80%] ${div2Visible ? 'transition-opacity duration-1000 ease-in' : 'opacity-0'}`}><img src={require("../assets/sara/Retention-2.png")} className="w-full h-full object-fit rounded-lg" /></div>
               <div className={`absolute bottom-[16%] left-[50%] z-1  w-[50%] h-[80%] ${div3Visible ? 'transition-opacity duration-1000 ease-in' : 'opacity-0'}`}><img src={require("../assets/sara/Retention-3.png")} className="w-full h-full object-fit rounded-lg" /></div>
            </div>
         </div> */}
         <div className="relative flex flex-col w-full h-[110vh]  text-black-500 justify-center items-center gap-4 bg-gray-200 px-5 pb-8">
            <div className="w-[100%] flex flex-col justify-center items-center">
               <h1 className="text-lg lg:text-5xl font-serif text-center text-black mb-1">ACCOUNTABILITY</h1>
               <h5 className="text-sm lg:text-2xl text-center font-serif mb-1 text-black">At our AI-driven product company, we are committed to upholding the utmost accountability and best practices. <br /> Transparency, quality, privacy, explainability, and fairness are paramount in every aspect of our product development</h5>
               <div className="flex justify-center">
                  <div className="grid grid-cols-3 gap-4">
                     {Accountability.map((image, index) => (
                        <img src={image.src} alt="" className={image.className} />
                     ))}
                  </div>
               </div>
            </div>
         </div>

         <div className="relative flex flex-col w-full h-[100vh] text-black justify-center items-center gap-4 bg-gray-200 px-5 pb-8">
            <div className="w-[100%] flex flex-col justify-center items-center">
               <h1 className="text-lg lg:text-5xl font-serif text-center text-black mb-1 mt-5">FUTURE</h1>
               <h5 className="text-sm lg:text-2xl font-serif text-center mb-1 text-black">In the future, digital content consumption will evolve with interactive search, AI-driven personalized recommendations, <br /> and shared viewing experiences. Creators will use efficient production tools to enhance content quality, fostering deeper user engagement and customization.
               </h5>
            </div>
            <div className="w-[100%] flex justify-center items-center">
               <img src={require("../assets/future3.png")} alt="" className="rounded-2xl w-[750px] h-[500px]" />
            </div>
         </div>

         <div className="relative flex flex-col w-full h-[100vh] text-black-500 justify-center items-center gap-4 bg-gray-200 px-5">
            <div className="w-[100%] flex flex-col  justify-center items-center">
               <h1 className="text-lg lg:text-5xl font-serif text-black text-center mb-1 animate-slide-in-left">SUPPORTED PLATFORMS</h1>
               <h5 className="text-sm lg:text-2xl text-center font-serif w-full mb-1 text-black">Our app supports a wide range of platforms, including iOS, Android, Mobile Web, Web, Tablet, as well as LG, <br /> Samsung, Android TV, Apple TV, and Vidaa TV. Enjoy seamless access to your favorite content across various devices.
               </h5>
            </div>
            <div className="w-[100%] flex justify-center items-center"
               onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave}
            >
               <img src={require("../assets/sara/all-devices-top-new.png")} alt="" className="rounded-2xl w-[700px] h-[500px]" />
            </div>
         </div>
      </div>
   );
};

const ListItem = ({ title, content }) => {
   return (
      <li className="mt-6 relative pl-5 md:pl-10">
         <div className="absolute h-2 w-2 bg-blue-500 rounded-full left-0 top-1/2 transform -translate-y-1/2" />
         <strong className="text-sm md:text-3xl">{title}:</strong>
         <p className="text-sm md:text-2xl">{content}</p>
      </li>
   );
};

export default Products;
